import { STATE_AVAILABLE } from '../../../constants'

export default {
  holidays: state => state.holidays,
  newsletters: state => state.newsletters,
  selectedHolidayYear: state => state.selectedHolidayYear,
  users: state => state.users,
  unModeratedAdverts: state => state.unModeratedAdverts,
  unModeratedBidCards: state => state.unModeratedBidCards.filter(bidCard => bidCard.state === STATE_AVAILABLE),
  unModeratedEmployerSearches: state => state.unModeratedEmployerSearches,
  unModeratedOccupations: state => state.unModeratedOccupations
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/getters.js